// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NativeCarouselHelper$PorterinFeature from "../../helpers/NativeCarouselHelper.mjs";
import * as CarouselIndicatorsCmp$PorterinFeature from "./CarouselIndicatorsCmp.mjs";

function NativeCarouselCmp(Props) {
  var class_nameOpt = Props.class_name;
  var carousel_indicator_styles = Props.carousel_indicator_styles;
  var carousel_item_wrapper_class = Props.carousel_item_wrapper_class;
  var are_indicators_clickable = Props.are_indicators_clickable;
  var children = Props.children;
  var show_indicatorsOpt = Props.show_indicators;
  var delayOpt = Props.delay;
  var autoplayOpt = Props.autoplay;
  var is_mobileOpt = Props.is_mobile;
  var on_slide_changeOpt = Props.on_slide_change;
  var class_name = class_nameOpt !== undefined ? class_nameOpt : "";
  var show_indicators = show_indicatorsOpt !== undefined ? show_indicatorsOpt : true;
  var delay = delayOpt !== undefined ? delayOpt : 4000;
  var autoplay = autoplayOpt !== undefined ? autoplayOpt : true;
  var is_mobile = is_mobileOpt !== undefined ? is_mobileOpt : false;
  var on_slide_change = on_slide_changeOpt !== undefined ? on_slide_changeOpt : (function (param) {
        
      });
  var match = React.useState(function () {
        return {
                current: 0
              };
      });
  var setCurrentSlide = match[1];
  var currentSlide = match[0];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setTouchstartX = match$1[1];
  var touchstartX = match$1[0];
  var childrenCount = React.Children.count(children);
  var startTimer = NativeCarouselHelper$PorterinFeature.returnStartSetTimeoutId(autoplay, setCurrentSlide, childrenCount, currentSlide.current, is_mobile, delay);
  React.useEffect(function () {
        return (function (param) {
                  NativeCarouselHelper$PorterinFeature.stopTimer(autoplay, startTimer);
                });
      });
  React.useEffect((function () {
          Curry._1(on_slide_change, currentSlide.current);
        }), [currentSlide.current]);
  var setSlide = function (current) {
    if (is_mobile) {
      NativeCarouselHelper$PorterinFeature.scrollToSlide(current - 1 | 0, childrenCount);
      return ;
    } else {
      return Curry._1(setCurrentSlide, (function (param) {
                    return {
                            current: current
                          };
                  }));
    }
  };
  return React.createElement("div", undefined, React.createElement("div", {
                  className: class_name,
                  id: "carousel",
                  onMouseEnter: (function (param) {
                      NativeCarouselHelper$PorterinFeature.stopTimer(autoplay, startTimer);
                    }),
                  onMouseLeave: (function (param) {
                      Curry._1(setCurrentSlide, (function (prev) {
                              return {
                                      current: prev.current
                                    };
                            }));
                    }),
                  onTouchEnd: (function ($$event) {
                      var touchendX = NativeCarouselHelper$PorterinFeature.getTouchCoordinate($$event);
                      NativeCarouselHelper$PorterinFeature.autoScroll(touchstartX, touchendX, setCurrentSlide, childrenCount);
                    }),
                  onTouchStart: (function ($$event) {
                      NativeCarouselHelper$PorterinFeature.stopTimer(autoplay, startTimer);
                      Curry._1(setTouchstartX, NativeCarouselHelper$PorterinFeature.getTouchCoordinate($$event));
                    })
                }, NativeCarouselHelper$PorterinFeature.childrenWrapper(children, is_mobile, currentSlide.current, carousel_item_wrapper_class)), React.createElement("div", {
                  className: "carousel-indicators-wrapper"
                }, show_indicators ? React.createElement(CarouselIndicatorsCmp$PorterinFeature.make, {
                        currentSlide: currentSlide.current,
                        totalSlides: childrenCount,
                        setSlide: setSlide,
                        styles: carousel_indicator_styles,
                        isClickable: are_indicators_clickable
                      }) : null));
}

var make = NativeCarouselCmp;

export {
  make ,
}
/* react Not a pure module */
